<template>
  <div id="app">
    <div v-if="maintenanceMode" class="maintenance-banner">
      ⚠️ <strong>Warning:</strong> The API is currently under maintenance. Some features may not work properly. ⚠️
    </div>
    <router-view />
  </div>
</template>


<script>
export default {
  data() {
    return {
      currentVersion: process.env.VUE_APP_VERSION, // The current version of your app
      maintenanceMode: false,
    };
  },
  created() {
    this.checkForUpdates();
    setInterval(this.checkForUpdates, 60000); // Check every 60 seconds
  },
  methods: {
    async checkForUpdates() {
  
      try {

      
        await this.$store.dispatch("getVersionsWeb");
      
        
        let version  = this.$store.state.web_version_api;
        // console.log('current version--',this.currentVersion);
        // console.log('API version--',version);
      if(version != '' && version !=undefined && version != null)
        if (version > this.currentVersion) {
        this.maintenanceMode = true;
          window.location.reload();
        
        }
      } catch (error) {
        console.error('Failed to check for updates:', error);
      }
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  background-color: #ffcc00; /* Caution yellow */
  color: black; /* High contrast text */
  text-align: center;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 4px solid black; /* Strong caution effect */
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000; /* Ensure it stays on top */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>
